import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import moment from 'moment';
import JobLicenseApi from '../../../services/workers/jobLicense/JobLicenseApi';
import JobLicenseService from '../../../services/workers/jobLicense/JobLicenseService';
import { CcusMasterService } from '../../../services/CcusMasters';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

import { WorkerHeader } from '../header/WorkerHeader';
import JobLicenseForm from '../form/JobLicenseForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';
import ConfirmationSafetyDocItemDialog from '../dialog/ConfirmationSafetyDocItemDialog';
import { FetchCcusDescription } from '../../FetchCcusDescription';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import { validationByJoi } from '../../../utilities/commonValidation';
import {
  extractErrorMessage,
  getZendeskArticleUrl,
} from '../../../utilities/commonUtil';
import { convertDate } from '../../../utilities/validateDateUtil';
import {
  validExpirationDate,
  isEmptyOrValidInputDate,
  calculationOfValidityPeriod,
  expireDateSameOrLaterThanTakeDate,
} from '../../../utilities/dateSelectorUtility';
import {
  attachDocumentDeleteState,
  attachDocumentWorkerCodesRead,
  attachDocumentWorkerUploadState,
  attachDocumentWorkerDownload,
  attachDocumentFilesCheck,
} from '../../../utilities/attachDocumentUtil';
import EventMg, { EventType } from '../../../utilities/EventManager';

import {
  ENV_VARS,
  WORKER_TAB,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  ATTACH_DOCUMENT_TYPE_WORKER,
  SAFETY_DOC_ITEM_VALIDATE,
  PERIOD_KIND,
  DATE_TIME_FORMAT,
  ZENDESK_LINK_IDS,
  ZENDESK_URL_GUIDE,
} from '../../../utilities/constants';

import styles from '../../../styles/componentStyle/workerForm/workerForm.scss';
import { MoveLeftIcon } from '../../icons/MoveLeftIcon';

/**
 * 職種・免許・資格ページ
 * @props {string}companyId:会社ID
 * @props {string}workerId:作業員ID
 * @props {object}pageStatus:ページ情報 (新規・詳細・編集)
 * @props {Boolean}isAlreadyCcusConnect:CCUSと連携しているか？
 * @props {Boolean}isAgencyRegister:代理ログインか？
 * @props {string}linkedToCcusDate:CCUSと連携した時間
 * @props {function}callFetchCcusWorkersData:CCUS情報取得処理
 */
export class JobLicense extends React.Component {
  state = {
    header: {
      // 職種・免許・資格ヘッダー用プロパティ
      LinkButtonObject: {}, // 作業員一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    jobLicense: {
      worker_jobs: [], // 職種
      worker_core_technicians: [], // 基幹技能者ブロック
      worker_engineer_licenses: [], // 技能士
      worker_licenses: [], // 免許資格
      ccus_worker_jobs: [], // CCUSから取得した職種
      ccus_worker_core_technicians: [], // CCUSから取得した基幹技能者ブロック
      ccus_worker_engineer_licenses: [], // CCUSから取得した技能士
      ccus_worker_licenses: [], // CCUSから取得した免許資格
    },
    comboBoxList: {
      // コンボボックスリスト
      workerJobs: {}, // 職種
      workerCoreTechnicians: {}, // 基幹技能者ブロック
      workerEngineerLicenses: {}, // 技能士
      workerLicenses: {}, // 免許資格
    },
    validErrorMessage: {
      // バリデーションエラーメッセージ
      jobLicense: {
        worker_jobs: {}, // 職種
        worker_core_technicians: {}, // 基幹技能者ブロック
        worker_engineer_licenses: {}, // 技能士
        worker_licenses: {}, // 免許資格
        attachDocuments_License: {}, // 証明書・免許証
      },
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    confirmationModalSafetyDocItem: {
      errorPropertyList: [],
    },
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
    attachDocumentCodes_License: [], // ファイル添付 免許資格 証明書・免許証 選択項目
    attachDocuments_License: [], // ファイル添付 免許資格 証明書・免許証 内容
    coreTechnicianValidPeriodsList: [], // 登録基幹技能者の有効期間情報
    licentiateValidPeriodsList: [], // 保有資格の有効期間情報
    tempCcusInfoTranscriptionPropertyName: null, // すべて転記時のプロパティ名の保管変数
    roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = true; // 多重更新防止Flag

    if (
      !(
        props.pageStatus === WORKER_PAGE_STATUS.CONFIRM ||
        props.pageStatus === WORKER_PAGE_STATUS.EDIT
      )
    ) {
      throw new Error('JobLicense.jsx constructor props.pageStatus');
    }
    if (_.isUndefined(props.workerId)) {
      throw new Error('JobLicense.jsx constructor props.workerId');
    }
    if (_.isUndefined(props.companyId)) {
      throw new Error('JobLicense.jsx constructor props.companyId');
    }

    // JobLicenseForm.jsxに渡すイベント
    this.events.addNewBlock = this.addNewBlock.bind(this);
    this.events.inputValueSearch = this.inputValueSearch.bind(this);
    this.events.setJobValues = this.setJobValues.bind(this);
    this.events.deleteValue = this.deleteValue.bind(this);
    this.events.setCCUSValuesJobLicense = this.setCCUSValuesJobLicense.bind(
      this
    );
    this.events.uploadFile = this.uploadFile.bind(this);
    this.events.download = this.download.bind(this);
    this.events.deleteFile = this.deleteFile.bind(this);
    this.events.setMessage = this.setMessage;
    this.events.calculationExpiredDate = this.calculationExpiredDate.bind(this);
    this.events.showCcusInfoTranscriptionAgreementDialog = this.showCcusInfoTranscriptionAgreementDialog.bind(
      this
    );
    this.state.roanToChoseiFlg = props.roanToChoseiFlg;

    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    this.today = moment(new Date(), DATE_TIME_FORMAT.slashDateFormat).format(
      DATE_TIME_FORMAT.slashDateFormat
    );
    const stateValue = _.cloneDeep(this.state);
    await JobLicenseApi.fetchJobLicense(
      this.props.companyId,
      this.props.workerId
    ).then(response => {
      if (response.result) {
        stateValue.jobLicense = {
          ...stateValue.jobLicense,
          ...response.data.entities,
        };

        if (!_.isArray(response.data.entities.worker_documents)) {
          throw new Error('JobLicense.jsx componentDidMount worker_documents');
        }
        stateValue.attachDocuments_License =
          response.data.entities.worker_documents;
      }
    });

    // 添付ファイル情報 選択項目の小分類コード一覧を取得する
    await attachDocumentWorkerCodesRead(
      stateValue,
      ['attachDocumentCodes_License'],
      [ATTACH_DOCUMENT_TYPE_WORKER.LICENSE_QUALIFICATION]
    );

    // 登録基幹技能者の有効期間を取得する
    await CcusMasterService.fetchCoreTechnicianValidPeriods()
      .then(response => {
        stateValue.coreTechnicianValidPeriodsList =
          response.data.entities.core_technician_valid_periods;
      })
      .catch(error => {
        console.log(error);
      });

    // 免許・資格の有効期間を取得する
    await CcusMasterService.fetchLicentiateValidPeriods()
      .then(response => {
        stateValue.licentiateValidPeriodsList =
          response.data.entities.licentiate_valid_periods;
      })
      .catch(error => {
        console.log(error);
      });

    // 基幹技能者資格の中に有効期間が存在するか確認
    this.settingExpirationDateRelatedData(
      stateValue.jobLicense.worker_core_technicians,
      stateValue.coreTechnicianValidPeriodsList,
      'core_technician_code',
      'touroku_kikan_ginousya_code'
    );
    // 技能士資格の中に有効期間が存在するか確認
    this.settingExpirationDateRelatedData(
      stateValue.jobLicense.worker_engineer_licenses,
      stateValue.licentiateValidPeriodsList,
      'engineer_licenses_code',
      'licentiate_cd'
    );
    // 免許資格の中に有効期間が存在するか確認
    this.settingExpirationDateRelatedData(
      stateValue.jobLicense.worker_licenses,
      stateValue.licentiateValidPeriodsList,
      'licenses_code',
      'licentiate_cd'
    );

    // CCUS基幹技能者資格の中に有効期間が存在するか確認
    this.settingExpirationDateRelatedData(
      stateValue.jobLicense.ccus_worker_core_technicians,
      stateValue.coreTechnicianValidPeriodsList,
      'core_technician_code',
      'touroku_kikan_ginousya_code'
    );
    // CCUS技能士資格の中に有効期間が存在するか確認
    this.settingExpirationDateRelatedData(
      stateValue.jobLicense.ccus_worker_engineer_licenses,
      stateValue.licentiateValidPeriodsList,
      'engineer_licenses_code',
      'licentiate_cd'
    );
    // CCUS免許資格の中に有効期間が存在するか確認
    this.settingExpirationDateRelatedData(
      stateValue.jobLicense.ccus_worker_licenses,
      stateValue.licentiateValidPeriodsList,
      'licenses_code',
      'licentiate_cd'
    );

    // 編集時のみコンボボックスの中身を取得する
    // 詳細時は必要ないため、早期 return する
    if (this.props.pageStatus.ID !== WORKER_PAGE_STATUS.EDIT.ID) {
      this.setState(stateValue);
      return;
    }

    const params = JobLicenseService.createFetchComboBoxListParam();
    await Promise.all([
      CcusMasterService.jobs(params),
      CcusMasterService.coreTechnicians(params),
      CcusMasterService.engineerLicenses(params),
      CcusMasterService.licenses(params),
    ]).then(responses => {
      if (_.some(responses, response => response.result === 0)) {
        return;
      }

      const [
        ginou_syokusyus,
        touroku_kikan_ginousyas,
        technician_licentiates,
        qualification_license_licentiates,
      ] = responses;

      stateValue.comboBoxList.workerJobs =
        ginou_syokusyus.data.entities.ginou_syokusyus;
      stateValue.comboBoxList.workerCoreTechnicians =
        touroku_kikan_ginousyas.data.entities.touroku_kikan_ginousyas;
      stateValue.comboBoxList.workerEngineerLicenses =
        technician_licentiates.data.entities.technician_licentiates;
      stateValue.comboBoxList.workerLicenses =
        qualification_license_licentiates.data.entities.qualification_license_licentiates;
    });

    // CCUSから情報を取得ボタンを押された後の処理
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      EventMg.addEventListener(EventType.FETCH_CCUS_INFO, async () => {
        // CCUS情報の再取得
        await JobLicenseApi.fetchJobLicense(
          this.props.companyId,
          this.props.workerId
        ).then(response => {
          if (response.result) {
            const stateValue = _.cloneDeep(this.state);
            stateValue.jobLicense.ccus_worker_jobs =
              response.data.entities.ccus_worker_jobs;
            stateValue.jobLicense.ccus_worker_core_technicians =
              response.data.entities.ccus_worker_core_technicians;
            stateValue.jobLicense.ccus_worker_engineer_licenses =
              response.data.entities.ccus_worker_engineer_licenses;
            stateValue.jobLicense.ccus_worker_licenses =
              response.data.entities.ccus_worker_licenses;
            this.setState(stateValue);
          }
        });
      });
    }

    this.setState(stateValue, () => {
      this.updatingFlag = false; // 画面ロード後更新可能になる
    });
  }

  /**
   * React Component LifeCycle
   * コンポーネントがアンマウントされる時
   * */
  componentWillUnmount() {
    // アンマウントされる時にEventListenerを削除する
    EventMg.deleteEvent(EventType.FETCH_CCUS_INFO);
  }

  /**
   * 有効期限関係のデータの設定
   * @param {object} registeredLicenseData: 登録済み資格情報
   * @param {object} licenseMaster: 有効期間マスタ
   * @param {String} targetPropertyName: 登録済み資格情報の紐付けたいプロパティ名
   * @param {String} searchPropertyName: 有効期間マスタの紐づけたいプロパティ名
   * */
  settingExpirationDateRelatedData = (
    registeredLicenseData,
    licenseMaster,
    targetPropertyName,
    searchPropertyName
  ) => {
    if (registeredLicenseData.length > 0) {
      _.map(registeredLicenseData, licenseInfo => {
        const tempArray = _.filter(licenseMaster, it => {
          return licenseInfo[targetPropertyName] === it[searchPropertyName];
        });
        if (tempArray.length > 0) {
          // 有効期間マスタに対象のデータがあった場合は有効期間用のオブジェクトを設定して、終身資格の場合は有効期限年月日を非表示にする
          licenseInfo.validPeriodObject = tempArray[0];
          licenseInfo.showExpireDate = !(
            _.has(licenseInfo.validPeriodObject, 'period_kind') === true &&
            licenseInfo.validPeriodObject.period_kind ===
              PERIOD_KIND.LIFETIME_ENTITLEMENT.ID
          );
        } else {
          licenseInfo.validPeriodObject = {};
          licenseInfo.showExpireDate = true;
        }

        if (
          targetPropertyName === 'core_technician_code' &&
          isNullOrUndefinedOrEmptyStr(
            licenseInfo.core_technician_expire_date
          ) === false
        ) {
          licenseInfo.warningMessage = this.searchWarningMessage(
            licenseInfo.core_technician_name,
            licenseInfo.core_technician_take_date,
            licenseInfo.core_technician_expire_date
          );
        } else if (
          targetPropertyName === 'engineer_licenses_code' &&
          isNullOrUndefinedOrEmptyStr(
            licenseInfo.engineer_licenses_expire_date
          ) === false
        ) {
          licenseInfo.warningMessage = this.searchWarningMessage(
            licenseInfo.engineer_licenses_name,
            licenseInfo.engineer_licenses_take_date,
            licenseInfo.engineer_licenses_expire_date
          );
        } else if (
          targetPropertyName === 'licenses_code' &&
          isNullOrUndefinedOrEmptyStr(licenseInfo.licenses_expire_date) ===
            false
        ) {
          licenseInfo.warningMessage = this.searchWarningMessage(
            licenseInfo.licenses_name,
            licenseInfo.licenses_take_date,
            licenseInfo.licenses_expire_date
          );
        }
      });
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 作業員一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    // 編集ボタン作成
    state.headerButtonObject.label = data.header.confirm.button.edit.label;
    state.headerButtonObject.className =
      data.header.confirm.button.edit.className;
    state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.handlerUpdate.bind(this);
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 作業員一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 職種・免許・資格詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.JOB_LICENSE.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * 職種・免許・資格編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerEdit', {
      state: {
        id: `${WORKER_TAB.JOB_LICENSE.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを表示する
   * */
  showCcusInfoTranscriptionAgreementDialog = name => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus =
      DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id;
    state.tempCcusInfoTranscriptionPropertyName = name;
    this.setState(state);
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを閉じる
   * */
  closeCcusInfoTranscriptionAgreementDialog = () => {
    const state = _.cloneDeep(this.state);
    const keyName = _.cloneDeep(state.tempCcusInfoTranscriptionPropertyName);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.tempCcusInfoTranscriptionPropertyName = null;
    this.setState(state, () => this.setCCUSValuesJobLicense(keyName));
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 更新を実行する前に実行する処理
   * バリデーションチェックと、要入力ダイアログ表示
   */
  handlerUpdate = () => {
    if (this.validateAll() === false) {
      return;
    }

    const resultValidate = this.validateAllSafetyDocItem();
    if (resultValidate.status === true) {
      this.updateJobLicense();
      return;
    }

    const state = _.cloneDeep(this.state);
    const { messages } = resultValidate;
    state.dialogStatus = DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id;
    state.confirmationModalSafetyDocItem.errorPropertyList = [];
    Object.keys(messages).forEach(key => {
      Object.values(messages[key]).forEach(() => {
        const constName = _.get(
          _.find(SAFETY_DOC_ITEM_VALIDATE.JOB_LICENSE, message => {
            return message.KEY === key;
          }),
          'TEXT'
        );
        if (!_.isUndefined(constName)) {
          state.confirmationModalSafetyDocItem.errorPropertyList.push(
            constName
          );
        } else {
          throw new Error('JobLicense.jsx handlerUpdate message property');
        }
      });
    });

    this.setState(state);
  };

  getStateWithConvertedDate = () => {
    const state = _.cloneDeep(this.state);
    // 基幹技能者
    _.each(state.jobLicense.worker_core_technicians, (item, index) => {
      // 登録基幹技能者取得年月日の月と日を『0』埋めしている
      state.jobLicense.worker_core_technicians[
        index
      ].core_technician_take_date = convertDate(item.core_technician_take_date);
      // 有効期限年月日の月と日を『0』埋めしている
      state.jobLicense.worker_core_technicians[
        index
      ].core_technician_expire_date = convertDate(
        item.core_technician_expire_date
      );
    });

    // 技能士
    _.each(state.jobLicense.worker_engineer_licenses, (item, index) => {
      // 技能士取得年月日の月と日を『0』埋めしている
      state.jobLicense.worker_engineer_licenses[
        index
      ].engineer_licenses_take_date = convertDate(
        item.engineer_licenses_take_date
      );
      // 有効期限年月日の月と日を『0』埋めしている
      state.jobLicense.worker_engineer_licenses[
        index
      ].engineer_licenses_expire_date = convertDate(
        item.engineer_licenses_expire_date
      );
    });

    // 免許資格
    _.each(state.jobLicense.worker_licenses, (item, index) => {
      // 免許資格取得年月日の月と日を『0』埋めしている
      state.jobLicense.worker_licenses[index].licenses_take_date = convertDate(
        item.licenses_take_date
      );
      // 有効期限年月日の月と日を『0』埋めしている
      state.jobLicense.worker_licenses[
        index
      ].licenses_expire_date = convertDate(item.licenses_expire_date);
    });
    return state;
  };

  /**
   * 作業者（職種・免許・資格）を更新する
   */
  updateJobLicense() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const state = this.getStateWithConvertedDate();

    JobLicenseApi.updateJobLicense(this.props.companyId, this.props.workerId, {
      ...state.jobLicense,
      worker_documents: state.attachDocuments_License,
    })
      .then(response => {
        if (response.result === true) {
          this.updatingFlag = false;
          this.moveToWorkerConfirm();
          return;
        }

        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(response);
        this.updatingFlag = false;
        this.setState(state);
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(error);
        this.updatingFlag = false;
        this.setState(state);
      });
  }

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * 入力項目を追加する
   * @param {string} keyName: プロパティ名
   * @param {object} obj: 追加対象のオブジェクト
   */
  addNewBlock(keyName, obj) {
    const state = _.cloneDeep(this.state);
    const targetValues = state.jobLicense[keyName];
    targetValues.push(obj);
    this.setState(state);
  }

  /**
   * 取得年月日から有効期限年月日を自動計算する
   * @param {object} value: 配列要素
   * @param {int} index: 配列要素番号
   * @param {string} targetKeyName: プロパティ名
   */
  calculationExpiredDate(value, index, targetKeyName) {
    const stateValue = _.cloneDeep(this.state);
    if (targetKeyName === 'worker_core_technicians') {
      if (
        isNullOrUndefinedOrEmptyStr(value.core_technician_code) === false &&
        isEmptyOrValidInputDate(value.core_technician_take_date) === false &&
        _.has(value, 'validPeriodObject') === true &&
        isNullOrUndefinedOrEmptyStr(value.validPeriodObject.period_kind) ===
          false
      ) {
        value.core_technician_expire_date = calculationOfValidityPeriod(
          value.core_technician_take_date,
          value.validPeriodObject
        );

        value.warningMessage = this.searchWarningMessage(
          value.core_technician_name,
          value.core_technician_take_date,
          value.core_technician_expire_date
        );
      }
    } else if (targetKeyName === 'worker_engineer_licenses') {
      if (
        isNullOrUndefinedOrEmptyStr(value.engineer_licenses_code) === false &&
        isEmptyOrValidInputDate(value.engineer_licenses_take_date) === false &&
        _.has(value, 'validPeriodObject') === true &&
        isNullOrUndefinedOrEmptyStr(value.validPeriodObject.period_kind) ===
          false
      ) {
        value.engineer_licenses_expire_date = calculationOfValidityPeriod(
          value.engineer_licenses_take_date,
          value.validPeriodObject
        );

        value.warningMessage = this.searchWarningMessage(
          value.engineer_licenses_name,
          value.engineer_licenses_take_date,
          value.engineer_licenses_expire_date
        );
      }
    } else if (targetKeyName === 'worker_licenses') {
      if (
        isNullOrUndefinedOrEmptyStr(value.licenses_code) === false &&
        isEmptyOrValidInputDate(value.licenses_take_date) === false &&
        _.has(value, 'validPeriodObject') === true &&
        isNullOrUndefinedOrEmptyStr(value.validPeriodObject.period_kind) ===
          false
      ) {
        value.licenses_expire_date = calculationOfValidityPeriod(
          value.licenses_take_date,
          value.validPeriodObject
        );

        value.warningMessage = this.searchWarningMessage(
          value.licenses_name,
          value.licenses_take_date,
          value.licenses_expire_date
        );
      }
    }

    stateValue.jobLicense[targetKeyName][index] = value;
    this.validateSingleJob(stateValue, targetKeyName);
    this.setState(stateValue);
  }

  /**
   * 入力値をコンボボックスから検索
   * @param {array} targetValues 該当項目の入力値
   * @param {array} comboBoxList コンボボックスリスト
   * @param {string} value 入力値
   * @param {int} index 要素数 ※コンボボックスの複数入力が行えない場合、-1をセット
   * @param {object} keyParams キーパラメータ
   */
  inputValueSearch(targetValues, comboBoxList, value, index, keyParams) {
    const matchItem = _.find(
      comboBoxList,
      item => item[keyParams.searchKey] === value
    );
    targetValues[index] = {
      ...targetValues[index],
      [keyParams.codeKey]: _.isUndefined(matchItem)
        ? '0'
        : matchItem[keyParams.codeKey],
      [keyParams.searchKey]: value,
    };
    if (!_.isUndefined(keyParams.codeKeyL)) {
      targetValues[index] = {
        ...targetValues[index],
        [keyParams.codeKeyL]: _.isUndefined(matchItem)
          ? '0'
          : matchItem[keyParams.codeKeyL],
      };
    }
    this.setJobValues(keyParams.targetKey, targetValues, index);
  }

  /**
   * 入力値を削除
   * @param {array} targetValues 該当項目の入力値
   * @param {int} index 要素数
   * @param {object} keyParams キーパラメータ
   */
  deleteValue(targetValues, index, keyParams) {
    const stateValue = _.cloneDeep(this.state);
    targetValues.splice(index, 1);
    stateValue.jobLicense[keyParams.targetKey] = targetValues;
    this.validateSingleJob(stateValue, keyParams.targetKey);
    this.setState(stateValue);
  }

  /**
   * CCUS情報を転記する
   * @param {string} keyName: プロパティ名
   */
  setCCUSValuesJobLicense(keyName) {
    if (keyName) {
      const state = _.cloneDeep(this.state);
      state.jobLicense[keyName] = _.cloneDeep(
        state.jobLicense[`ccus_${keyName}`]
      );
      if (keyName !== 'worker_jobs') {
        _.each(state.jobLicense[keyName], item => {
          if (!_.has(item, 'worker_documents')) {
            item.worker_documents = [];
          }
        });
      }
      this.validateSingleJob(state, keyName);
      this.setState(state);
    }
  }

  /**
   * 職種・免許・資格データをセットする
   * @param {string} keyName: プロパティ名
   * @param {Object} data: 更新対象のデータ
   * @param {Integer} index: 配列のindex
   */
  setJobValues(keyName, data, index) {
    const stateValue = _.cloneDeep(this.state);

    // 選択した資格に有効期間が存在するか確認
    let tempArray = [];
    if (keyName === 'worker_core_technicians') {
      tempArray = _.filter(stateValue.coreTechnicianValidPeriodsList, it => {
        return (
          data[index].core_technician_code === it.touroku_kikan_ginousya_code
        );
      });

      // 有効期限切れチェック
      if (
        isNullOrUndefinedOrEmptyStr(data[index].core_technician_expire_date) ===
        false
      ) {
        data[index].warningMessage = this.searchWarningMessage(
          data[index].core_technician_name,
          data[index].core_technician_take_date,
          data[index].core_technician_expire_date
        );
      }
    } else if (keyName === 'worker_engineer_licenses') {
      tempArray = _.filter(stateValue.licentiateValidPeriodsList, it => {
        return data[index].engineer_licenses_code === it.licentiate_cd;
      });

      // 有効期限切れチェック
      if (
        isNullOrUndefinedOrEmptyStr(
          data[index].engineer_licenses_expire_date
        ) === false
      ) {
        data[index].warningMessage = this.searchWarningMessage(
          data[index].engineer_licenses_name,
          data[index].engineer_licenses_take_date,
          data[index].engineer_licenses_expire_date
        );
      }
    } else if (keyName === 'worker_licenses') {
      tempArray = _.filter(stateValue.licentiateValidPeriodsList, it => {
        return data[index].licenses_code === it.licentiate_cd;
      });

      // 有効期限切れチェック
      if (
        isNullOrUndefinedOrEmptyStr(data[index].licenses_expire_date) === false
      ) {
        data[index].warningMessage = this.searchWarningMessage(
          data[index].licenses_name,
          data[index].licenses_take_date,
          data[index].licenses_expire_date
        );
      }
    }

    if (tempArray.length > 0) {
      // 有効期間マスタに対象のデータがあった場合は有効期間用のオブジェクトを設定して、終身資格の場合は有効期限年月日を非表示にする
      data[index].validPeriodObject = tempArray[0];
      if (
        _.has(data[index].validPeriodObject, 'period_kind') === true &&
        data[index].validPeriodObject.period_kind ===
          PERIOD_KIND.LIFETIME_ENTITLEMENT.ID
      ) {
        data[index].showExpireDate = false;
        data[index].warningMessage = null;

        if (keyName === 'worker_core_technicians') {
          data[index].core_technician_expire_date = null;
        } else if (keyName === 'worker_engineer_licenses') {
          data[index].engineer_licenses_expire_date = null;
        } else if (keyName === 'worker_licenses') {
          data[index].licenses_expire_date = null;
        }
      }
    } else {
      data[index].validPeriodObject = {};
      data[index].showExpireDate = true;
    }

    Object.assign(stateValue.jobLicense[keyName], data);
    this.validateSingleJob(stateValue, keyName);
    this.setState(stateValue);
  }

  /**
   * 入力されるごとにバリデーションを実行する
   * @param {object} state: ステート情報
   * @param {string} keyName: プロパティ名
   */
  validateSingleJob = (state, keyName) => {
    if (isNullOrUndefinedOrEmptyStr(keyName)) {
      return state;
    }

    const schema = JobLicenseService.createValidateSchema();
    const result = validationByJoi(
      _.get(schema, [keyName]),
      state.jobLicense[keyName]
    );

    state.validErrorMessage.jobLicense[keyName] = result.messages;

    if (!attachDocumentFilesCheck(state.attachDocuments_License)) {
      state.validErrorMessage.jobLicense.attachDocuments_License = {
        0: '添付ファイルエラー',
      };
    } else {
      state.validErrorMessage.jobLicense.attachDocuments_License = {};
    }

    this.validateWorkerDocuments(state, 'worker_core_technicians');
    this.validateWorkerDocuments(state, 'worker_engineer_licenses');
    this.validateWorkerDocuments(state, 'worker_licenses');
  };

  validateWorkerDocuments = (state, keyName) => {
    _.each(state.jobLicense[keyName], (item, index) => {
      if (
        !attachDocumentFilesCheck(
          state.jobLicense[keyName][index].worker_documents
        )
      ) {
        state.validErrorMessage.jobLicense[keyName].worker_documents = {
          0: '添付ファイルエラー',
        };
        return false;
      } else {
        delete state.validErrorMessage.jobLicense[keyName].worker_documents;
      }
    });
  };

  /**
   * 全体のバリデーションを実行する
   */
  validateAll = () => {
    const stateValue = _.cloneDeep(this.state);

    const result = validationByJoi(
      Joi.object().keys(JobLicenseService.createValidateSchema()),
      {
        ...stateValue.jobLicense,
      }
    );

    if (result.status === false) {
      stateValue.validErrorMessage.jobLicense = {
        ...stateValue.validErrorMessage.jobLicense,
        ...result.messages,
      };
    }

    stateValue.validErrorMessage.jobLicense.attachDocuments_License = attachDocumentFilesCheck(
      stateValue.attachDocuments_License
    )
      ? {}
      : {
          0: '添付ファイルエラー',
        };

    this.validateWorkerDocuments(stateValue, 'worker_core_technicians');
    this.validateWorkerDocuments(stateValue, 'worker_engineer_licenses');
    this.validateWorkerDocuments(stateValue, 'worker_licenses');

    this.setState(stateValue);

    return (
      Object.keys(stateValue.validErrorMessage.jobLicense.worker_jobs).length +
        Object.keys(
          stateValue.validErrorMessage.jobLicense.worker_core_technicians
        ).length +
        Object.keys(
          stateValue.validErrorMessage.jobLicense.worker_engineer_licenses
        ).length +
        Object.keys(stateValue.validErrorMessage.jobLicense.worker_licenses)
          .length +
        Object.keys(
          stateValue.validErrorMessage.jobLicense.attachDocuments_License
        ).length ===
      0
    );
  };

  /**
   * 安全書類項目用バリデーション(要入力)
   */
  validateAllSafetyDocItem = () => {
    const state = _.cloneDeep(this.state);
    const schema = JobLicenseService.createValidateSchemaSafetyDocItem(
      state.jobLicense
    );

    const result = validationByJoi(Joi.object().keys(schema), state.jobLicense);
    return result;
  };

  attachDocumentsLicense = (index, keyName) => {
    if (_.isUndefined(index)) {
      return this.state.attachDocuments_License;
    } else {
      return this.state.jobLicense[keyName][index].worker_documents;
    }
  };

  /**
   * 添付書類 ファイル選択処理
   */
  uploadFile = async (file, typeL, typeS, index, keyName) => {
    attachDocumentWorkerUploadState(
      this.attachDocumentsLicense(index, keyName),
      documents => {
        if (_.isUndefined(index)) {
          this.setState({ attachDocuments_License: documents }, () =>
            this.validateAll()
          );
        } else {
          this.setState(
            {
              jobLicense: {
                ...this.state.jobLicense,
                [keyName]: this.state.jobLicense[keyName].map((obj, idx) =>
                  idx === index
                    ? Object.assign(obj, { worker_documents: documents })
                    : obj
                ),
              },
            },
            () => this.validateAll()
          );
        }
      },
      this.props.companyId,
      this.props.workerId,
      file,
      typeL,
      typeS
    );
  };

  /**
   * 添付書類 ファイルダウンロード処理
   */
  async download(fileId) {
    attachDocumentWorkerDownload(
      () => {
        this.setState({
          dialogStatus: DIALOG_STATUS.attachFileNotExistDialogEnagled.id,
        });
      },
      this.props.companyId,
      this.props.workerId,
      fileId
    );
  }

  /**
   * 添付書類 ファイル登録削除処理
   */
  deleteFile = (file, index, keyName) => {
    attachDocumentDeleteState(
      this.attachDocumentsLicense(index, keyName),
      documents => {
        if (_.isUndefined(index)) {
          this.setState({ attachDocuments_License: documents }, () =>
            this.validateAll()
          );
        } else {
          this.setState(
            {
              jobLicense: {
                ...this.state.jobLicense,
                [keyName]: this.state.jobLicense[keyName].map((obj, idx) =>
                  idx === index
                    ? Object.assign(obj, { worker_documents: documents })
                    : obj
                ),
              },
            },
            () => this.validateAll()
          );
        }
      },
      file
    );
  };

  /**
   * 警告メッセージが存在するか検索する
   * @param {string} licenseName: 免許・証明書名
   * @param {string} takeDate: 取得年月日
   * @param {string} expireDate: 有効期限年月日
   * @return {string} message: 警告メッセージ
   */
  searchWarningMessage = (licenseName, takeDate, expireDate) => {
    let message = validExpirationDate(expireDate, licenseName, true);

    if (isNullOrUndefinedOrEmptyStr(message) === true) {
      message = expireDateSameOrLaterThanTakeDate(takeDate, expireDate);
    }

    return message;
  };

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  /**
   * CCUSから情報を取得するボタン・補足説明の表示
   */
  showFetchCcusDescription = () => {
    const REACT_APP_ZENDESK_URL = ENV_VARS.REACT_APP_ZENDESK_URL;
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      if (this.props.isAgencyRegister) {
        if (!_.has(this.props.agencyInfo, 'in_upstream_ccus_field_trees')) {
          return;
        } else {
          // 代行先の作業員
          const canFetchCcus =
            this.props.isAlreadyCcusConnect &&
            this.props.agencyInfo.in_upstream_ccus_field_trees &&
            this.props.isLinkedUser;
          // BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
          if (canFetchCcus && !this.props.isCcusJigyousyaDeleted) {
            if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-161')}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            } else {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-162')}
                  linkedToCcusDate={this.props.linkedToCcusDate}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            }
          } else {
            return (
              // 代行先のCCUSに登録された詳細情報はCCUSの制限により取得できません。<br>Buildeeに直接入力を行ってください。
              <FetchCcusDescription
                description={
                  <span>
                    CCUSから情報を取得することができません。赤字の条件が満たされていません。
                    <br />
                    CCUSから代行先の情報を取得するには、下記の条件をすべて満たす必要があります。
                    <br />
                    <br />
                    <ul className='fetch-ccus-description-message__text-list'>
                      {/*  BLDE_V2-50226 CCUS事業者IDは削除された場合に文言は赤色になる */}
                      {/* BLDE_V2-50623 代行先会社はCCUSと連携されているかどうかによって文言の色は変更する */}
                      <li
                        className={
                          this.props.isCcusJigyousyaConnected &&
                          this.props.isAlreadyCcusConnect &&
                          !this.props.isCcusJigyousyaDeleted
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          {messageUtility.getMessage('I-000-263')}
                        </span>
                      </li>
                      <li
                        className={
                          this.props.isLinkedUser ? '' : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          あなたのアカウントが代行先の連携ユーザーとして設定されている
                        </span>
                        {!this.props.isLinkedUser && (
                          <span>
                            （
                            <span
                              className='clickable-text'
                              onClick={() => {
                                masterSlideLoader.show('PrimeCcusPreview', {
                                  state: { id: this.props.companyId },
                                });
                              }}
                            >
                              こちら
                            </span>
                            から設定してください）
                          </span>
                        )}
                      </li>
                      <li
                        className={
                          this.props.agencyInfo.in_upstream_ccus_field_trees
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          施工体制のCCUS連携を行っているいずれかの現場で、代行先の会社があなたの会社の下位協力会社として登録されている
                        </span>
                        {!this.props.agencyInfo
                          .in_upstream_ccus_field_trees && (
                          <span>
                            （詳細は
                            <a
                              className='clickable-text'
                              href={`${getZendeskArticleUrl(
                                REACT_APP_ZENDESK_URL,
                                ZENDESK_LINK_IDS.CCUS_FIELD_TREES
                              )}`}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              こちら
                            </a>
                            をご確認ください。）
                          </span>
                        )}
                      </li>
                    </ul>
                  </span>
                }
                disabledCcusConnectionButton
              />
            );
          }
        }
      }
      //  BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
      if (
        (this.props.isAlreadyCcusConnect &&
          this.props.isCcusJigyousyaDeleted) ||
        !this.props.isCcusJigyousyaConnected
      ) {
        return null;
      }
      if (
        !this.props.isLinkedUser ||
        !this.props.ccusEngineerId ||
        !this.props.isAlreadyCcusConnect
      ) {
        return (
          <FetchCcusDescription
            disabledCcusConnectionButton
            description={
              <div>
                <p>
                  CCUSから情報を取得することができません。赤字の条件が満たされていません。
                </p>
                <p>
                  CCUSから情報を取得するには、下記の条件をすべて満たす必要があります。
                </p>
                <ul className='fetch-ccus-description-message__text-list'>
                  <li
                    className={!this.props.isLinkedUser ? 'text--negative' : ''}
                  >
                    <span className='fetch-ccus-description-message__text'>
                      あなたのアカウントが自社の連携ユーザーとして設定されている
                    </span>
                    {!this.props.isLinkedUser && (
                      <span>
                      （
                      <span
                        className='clickable-text'
                        onClick={() => {
                          masterSlideLoader.show('PrimeCcusPreview', {
                            state: { id: this.props.companyId },
                          });
                        }}
                      >
                        こちら
                      </span>
                        から設定してください）
                      </span>
                    )}
                  </li>
                  <li
                    className={
                      !this.props.ccusEngineerId ||
                      !this.props.isAlreadyCcusConnect
                        ? 'text--negative'
                        : ''
                    }
                  >
                    <span className='fetch-ccus-description-message__text'>
                      作業員の基本情報タブにCCUS技能者IDが登録されておりCCUS連携に成功している
                    </span>
                  </li>
                </ul>
                <br />
                <p>
                  作業員のCCUS連携の手順は
                  <a
                    className='clickable-text'
                    href={ZENDESK_URL_GUIDE.CCUS_WORKER_WARNING}
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    こちら
                  </a>
                  をご確認ください。
                </p>
              </div>
            }
          />
        );
      }
      if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-161')}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      } else {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-162')}
            linkedToCcusDate={this.props.linkedToCcusDate}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      }
    }
  };

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <WorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={
            Object.keys(this.state.validErrorMessage.jobLicense.worker_jobs)
              .length +
            Object.keys(
              this.state.validErrorMessage.jobLicense.worker_core_technicians
            ).length +
            Object.keys(
              this.state.validErrorMessage.jobLicense.worker_engineer_licenses
            ).length +
            Object.keys(this.state.validErrorMessage.jobLicense.worker_licenses)
              .length +
            Object.keys(
              this.state.validErrorMessage.jobLicense.attachDocuments_License
            ).length
          }
        />
        <div className='contruction-detail-view__bar' />

        <JobLicenseForm
          ccusDescription={this.showFetchCcusDescription()} /* CCUSから情報を取得するボタン・補足説明 */
          events={this.events}
          messages={this.state.validErrorMessage}
          formValues={this.state.jobLicense}
          disabledAll={this.props.pageStatus.DISABLED_ALL}
          comboBoxList={this.state.comboBoxList}
          attachDocumentCodes_License={this.state.attachDocumentCodes_License}
          attachDocuments_License={this.state.attachDocuments_License}
          isCcusJigyousyaDeleted={this.props.isCcusJigyousyaDeleted} // BLDE_V2-50226 CCUS事業者IDは削除されたかどうか決断
        />

        {/* 更新失敗時のダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateFailedDialogEnabled.id
          }
          title={messageUtility.getMessage('E-000-005')}
          message={this.state.informationModal.message}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.closeDialog()}
        />

        {/* 編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.moveToWorkerConfirm()}
          onCancel={() => this.closeDialog()}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />

        {/* CCUS全て転記ダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-164')}
          confirmButtonText={messageUtility.getMessage('I-000-165')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={
            <React.Fragment>
              {messageUtility.getMessage('I-000-166')}
              <MoveLeftIcon className='form-list__element-ccus-icon' />
              {messageUtility.getMessage('I-000-167')}
            </React.Fragment>
          }
          isNegative
          negativeButtonClassName='btn'
          rootClassName={styles.CcusInfoTranscriptionAgreementDialog}
          onConfirm={() => this.closeCcusInfoTranscriptionAgreementDialog()}
          onCancel={() => this.closeDialog()}
        />

        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={
            this.state.confirmationModalSafetyDocItem.errorPropertyList
          }
          onConfirm={() => {
            if (this.validateAll() !== true) {
              throw new Error('Confirmation safetyDocItemErrorDialogEnabled');
              // ダイアログが開いている場合に
              // 通常バリデートがエラーになっている場合はない想定をしている
            }
            this.updateJobLicense();
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
          onCancel={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />

        {/* 添付ファイルが存在しないときのエラー表示 */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.attachFileNotExistDialogEnagled.id
          }
          title={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <i
                className='icon-error'
                style={{
                  fontSize: 24,
                  color: 'red',
                }}
              />
              <p>エラーが発生しました。</p>
            </div>
          }
          message={'指定されたファイルが存在しません。'}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '作業員一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/worker/page/JobLicense.jsx